/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import cn from "classnames";
import Select from "react-select";

import {
  JobAdBox,
  MessageBox,
  Modal,
  LoadingIndicator,
  Highlights,
} from "components";
import Constants from "app_constants";
import Theme from "./theme";

import darkBG from "assets/img/dark-bg.jpg";
import googlePlay from "assets/img/google-play.png";

const jobCategories = Constants.jobCategories;
const options = [{ value: null, label: "Show All Ads" }];

for (const key in jobCategories) {
  options.push({ value: key, label: jobCategories[key] });
}

const HomeView = ({
  jobs,
  jobPublishedModal,
  paymentModal,
  registerModal,
  showJobPublishedModal,
  showRegisterModal,
  showPaymentModal,
  paginate,
  setSearchValue,
  search,
  messageBox,
  closeMessageBox,
  publishJobAd,
  loaded,
  filters,
  updateFilter,
  toggleFilters,
  toggleGrid,
  showFilters,
  isGrid,
  handleKeyDown,
  selectCategory,
  category,
}) => {
  return (
    <Theme>
      {Constants.metaTag}
      {loaded ? (
        <>
          <Modal
            title="Successful"
            content="You have successfully published a Job Ad. It will be visible after we verify it. That will take max 1 day!"
            modalActive={jobPublishedModal}
            showModal={showJobPublishedModal}
          />
          <Modal
            title="Successful"
            content="Payment is successful. You can publish job ad(s)."
            modalActive={paymentModal}
            showModal={showPaymentModal}
          />
          <Modal
            title="Successful"
            content="You have successfully registered. We have sent you an activation mail."
            modalActive={registerModal}
            showModal={showRegisterModal}
          />
          <section className="hero is-info welcome is-small">
            <div className="hero-body">
              <div className="container">
                <h1 className="title is-hidden-mobile">
                  Find a Remote Job Easily
                </h1>
                <h1 className="title is-4 is-hidden-tablet">
                  Find a Remote Job Easily
                </h1>
                <h2 className="subtitle is-hidden-mobile">
                  Browse job opportunities from the most remote-friendly
                  companies in the world.
                </h2>
                <p className="is-hidden-tablet">
                  Browse job opportunities from the most remote-friendly
                  companies in the world.
                </p>
                <br />
                <h4>
                  <i className="fas fa-star"></i>&nbsp;10k+ daily visitors
                </h4>
              </div>
            </div>
          </section>
          <a
            onClick={publishJobAd}
            className="title is-4 publish is-hidden-mobile"
          >
            <i className="fas fa-check"></i>&nbsp;Publish a Job Ad in 2 minutes,
            for free
          </a>
          <b
            onClick={publishJobAd}
            style={{ fontSize: 16 }}
            className="publish is-hidden-tablet"
          >
            <i className="fas fa-check"></i>&nbsp;Publish a Job Ad in 2 minutes,
            for free
          </b>
          <br /> <br />
          <div className="selectCategory is-hidden-desktop">
            <Select
              options={options}
              onChange={(e) => {
                selectCategory(e.value);
              }}
              placeholder="Select Category"
              value={options.find((option) => option.value === category)}
            />
          </div>
          <div className="field has-addons is-fullwidth searchBox">
            <div className="control searchInput">
              <input
                onChange={(e) => setSearchValue(e.target.value)}
                className="input is-info"
                type="text"
                placeholder="Search a job ad..."
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="control">
              <a onClick={search} className="button is-dark search">
                Search
              </a>
            </div>
            <div className="selectCategory is-hidden-touch">
              <Select
                options={options}
                onChange={(e) => {
                  selectCategory(e.value);
                }}
                placeholder="Select Category"
                value={options.find((option) => option.value === category)}
              />
            </div>
            <button
              className="button is-outlined is-dark filter"
              onClick={toggleFilters}
              onFocus={(e) => e.target.blur()}
            >
              <span className="icon">
                <i className="fas fa-filter"></i>
              </span>
              <span>Filter</span>
            </button>
            <button
              className="button is-outlined is-dark toggleGrid is-hidden-mobile"
              onClick={toggleGrid}
              onFocus={(e) => e.target.blur()}
            >
              <span className="icon">
                <i
                  className={cn("fas", isGrid ? "fa-list" : "fa-th-large")}
                ></i>
              </span>
            </button>
          </div>
          {showFilters && (
            <div className="filterSection">
              <label class="checkbox filter box">
                <input
                  type="checkbox"
                  checked={filters.worldwide}
                  onChange={(e) => {
                    updateFilter("worldwide", e.target.checked);
                  }}
                />
                <span>Show only world-wide jobs</span>
              </label>

              <label class="checkbox filter box">
                <input
                  type="checkbox"
                  checked={filters.compensation}
                  onChange={(e) => {
                    updateFilter("compensation", e.target.checked);
                  }}
                />
                <span>Show job ads with compensation info</span>
              </label>

              {/*
              <div className="box compensation">
                <p className="label">Compensation</p>
                <input
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="input is-info"
                  type="text"
                  placeholder="Min"
                />
                <input
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="input is-info"
                  type="text"
                  placeholder="Max"
                />

                <button onClick={paginate} className="button is-primary">
                  Save
                </button>
              </div>
              */}
            </div>
          )}
          <div className="separator" />
          <div className="columns is-multiline">
            {jobs.map(
              (jobAd, index) =>
                jobAd.published &&
                !(filters.worldwide && jobAd.regionalRestrictions) &&
                !(filters.compensation && !jobAd.compensation) && (
                  <div
                    className={cn("column", isGrid ? "is-half" : "is-full")}
                    key={index.toString()}
                  >
                    <JobAdBox jobAd={jobAd} isGrid={isGrid} />
                  </div>
                )
            )}
          </div>
          {loaded && jobs.length === 0 && (
            <p className="warning">
              <b>There isn't any result to show :(</b>
            </p>
          )}
          {!loaded && (
            <p className="warning">
              <b>Ads are loading...</b>
            </p>
          )}
          {jobs.length !== 0 && (
            <div className="loadMore">
              <button onClick={paginate} className="button">
                Load More
              </button>
            </div>
          )}
          <br />
          <div className="is-hidden-mobile">
            <Highlights />
          </div>
          <br />
          <div className="is-hidden-mobile">
            {messageBox && (
              <MessageBox background={darkBG} close={closeMessageBox} />
            )}
          </div>
          <div className="mobileApps is-hidden-mobile">
            <h4 className="title is-4">Download our Android App</h4>
            <img
              src={googlePlay}
              onClick={() => window.open(Constants.googlePlayURL, "_blank")}
              width="300"
            />
          </div>
        </>
      ) : (
        <LoadingIndicator />
      )}
    </Theme>
  );
};

export default HomeView;
